import React from 'react'


const BurgerMenu = (props) => (

    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 53" {...props}>
        <path d="M2 13.5h49a2 2 0 0 0 0-4H2a2 2 0 0 0 0 4zM2 28.5h49a2 2 0 0 0 0-4H2a2 2 0 0 0 0 4zM2 43.5h49a2 2 0 0 0 0-4H2a2 2 0 0 0 0 4z"/>
    </svg>
)


export default BurgerMenu


// WEBPACK FOOTER //
// ./src/components/_common/_icons/BurgerMenu.js